<template lang="pug">
	.expand-container(
		:class='showingState'
		ref='container'
		@mouseleave='setTimer'
		@mouseenter='clearTimer'
	)
		.button(@click='expand') {{ title }}
		.menu( ref='menu' )
			.option(
				v-for='option in options'

				:class='option.active === true ? "active" : ""'

				@click='optionClicked( option )'
			)
				span.bubble(
					v-if='option.color'
					:style='{ background: option.color }'
				)
				| {{ option.text }}
</template>

<script>
export default {
	name : 'button-expand',

	props : {

		title : {
			type : String,
		},

		options : {
			type : Array,
		},

	},

	data : () => ( {
		showingState : 'hidden',
		timerId      : null,
	} ),

	methods : {

		expand() {
			this.showingState = 'active';
		},

		setTimer() {

			this.timerId = window.setTimeout( () => {
				this.showingState = 'hidden';
			}, 200 );

		},

		clearTimer() {

			if ( this.timerId !== null ) {
				window.clearTimeout( this.timerId );
			}

		},

		optionClicked( option ) {

			if ( option.func ) {
				option.func();
				return;
			}

			this.$emit( 'optionClicked', option );
		},

	},

};
</script>

<style lang="scss">

.expand-container {
	border-radius: 12px;
	position: relative;

	&.active {

		&:hover {

			.button {
				box-shadow: none!important;
			}
		}

		.button {
			background: transparent;
			color: $color-secondary;
			font-weight: 600;
		}

		.menu {
			opacity: 1;
			pointer-events: all;
		}
	}

	&:hover {
		cursor: default;

		.button {
			box-shadow: $defaultBoxShadow!important;
		}
	}

	.button {
		position: relative;
		z-index: 2;
		box-shadow: none;
		transition: .2s ease-in-out;

		&:hover {
			box-shadow: $defaultBoxShadow!important;
		}
	}

	.menu {
		opacity: 0;
		pointer-events: none;
		position: absolute;
		border-radius: 22px;
		top: 0;
		left: 0;
		padding-top: 44px;
		width: 100%;
		box-shadow: $box-shadow__card;
		background: white;
		transition: .2s ease-in-out;
		overflow: hidden;

		.option {
			color: $blueGrey;
			padding: 8px 15px;
			font-size: 14px;
			display: flex;
			align-items: center;

			&:hover {
				cursor: pointer;
			}

			&.active {
				background-color: rgba( $color-primary, .28 );
				color: $color-primary;
				font-weight: 600;
			}

			.bubble {
				position: relative;
				height: 10px;
				width: 10px;
				border-radius: 3px;
				margin-right: 5px;
			}
		}
	}
}

</style>
